<div class="row text-center">
    <div class="col-12">
        <div class="page-title-header d-flex justify-content-between align-items-center mb-3">
            <h4 class="page-title fw-bold">{{ pageTitle }}</h4>
        </div>
        <div class="calendar-navigation">
            <div class="nav-arrows">
                <button type="button" class="nav-circle-btn" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate"
                    (viewDateChange)="closeOpenMonthViewDay()" aria-label="Previous month">
                    <i class="fas fa-chevron-left"></i>
                </button>
                <div class="month-title">
                    <h3 class="mb-0">{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
                </div>
                <button type="button" class="nav-circle-btn" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate"
                    (viewDateChange)="closeOpenMonthViewDay()" aria-label="Next month">
                    <i class="fas fa-chevron-right"></i>
                </button>
            </div>
            <div class="year-select-wrapper">
                <select class="year-select" [ngModel]="selectedYear" (ngModelChange)="onYearChange($event)" aria-label="Select year">
                    <option *ngFor="let y of yearOptions" [value]="y">{{ y }}</option>
                </select>
                <i class="fas fa-chevron-down year-select-caret"></i>
            </div>
        </div>
    </div>
</div>
<br />
<ng-template #customCellTemplate let-day="day" let-locale="locale">
    <div class="cal-cell-top">
        <span class="cal-day-badge" *ngIf="day.badgeTotal > 0">{{ day.badgeTotal }}</span>
        <span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
    </div>
    <div *ngFor="let e of day.events;let i=index">
        <div class="body-events eventsList" [ngStyle]="{'margin-top':'8px','background-color': (i==0 || i%2==0) ? '#00BCD4' : '#6ca36f'}"  
            (click)="handleEvent('Clicked', e , e.id)">{{e.title}}</div> 
    </div>
</ng-template>

<div [ngSwitch]="view">
    <!-- Fixed: Removed duplicate calendar-month-view component -->
    <mwl-calendar-month-view
        *ngSwitchCase="CalendarView.Month"
        [viewDate]="viewDate"
        [events]="events"
        [refresh]="refresh"
        [cellTemplate]="customCellTemplate"
        [activeDayIsOpen]="activeDayIsOpen"
        (dayClicked)="dayClicked($event.day)"
        (eventClicked)="handleEvent('Clicked', $event.event, $event.event.id)"
        (eventTimesChanged)="eventTimesChanged($event)">
    </mwl-calendar-month-view>

    <mwl-calendar-day-view
        *ngSwitchCase="CalendarView.Day"
        [viewDate]="viewDate"
        [events]="events"
        [refresh]="refresh"     
        (eventClicked)="handleEvent('Clicked', $event.event, $event.event.id)"
        (eventTimesChanged)="eventTimesChanged($event)">
    </mwl-calendar-day-view>
</div>

<!-- Everything you see below is just for the demo, you don't need to include it in your app -->
<div class="card flex justify-content-center" *ngIf="isAdd && !deleteConfirmVisible">
    <p-dialog header="Add New Event For {{actualDate}}" [(visible)]="visible" (click)="dialogCLose($event)" [style]="{width: '60vw'}">
        <div class="table-responsive">
            <form #f="ngForm" (ngSubmit)="addNewEvent()">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="lname">Event Title<span class="color">*</span>:</label>
                        <input class="form-control" [(ngModel)]="eventDetails.eventTitle" [ngModelOptions]="{standalone: true}" type="text" placeholder="Event Title" />
                        <div *ngIf="requiredFieldErrors.eventTitle" class="field-error">Please select required values</div>
                    </div>  
                    <div class="form-group col-md-6">
                        <label for="lname">Event Type<span class="color">*</span>:</label>
                        <select class="form-control" [(ngModel)]="eventDetails.eventType" (change)="changeEventTypeAdd($event)" [ngModelOptions]="{standalone: true}" placeholder="Choose Option">
                        <div *ngIf="requiredFieldErrors.eventType" class="field-error">Please select required values</div>
                            <option value="0" selected>Choose Option</option>
                            <option value="1">Call With Team</option>
                            <option value="2">Call With Member</option>
                            <option value="3" *ngIf="isMemberAdvocate">Call Between Member and Doctor</option>
                            <option value="4" *ngIf="isMemberAdvocate">Call Between Member and Nutritionist</option>
                            <option value="5" *ngIf="isMemberAdvocate">Call Between Member and Fitness Instructors</option>
                            <option value="6" *ngIf="isMemberAdvocate">Call Between Member and Psychologist</option>
                            <option value="7" *ngIf="isMemberAdvocate">Call Between Team and Doctor</option>
                            <option value="8" *ngIf="isMemberAdvocate">Call Between Team and Nutritionist</option>
                            <option value="9" *ngIf="isMemberAdvocate">Call Between Team and Fitness Instructors</option>
                            <option value="10" *ngIf="isMemberAdvocate">Call Between Team and Psychologist</option>
                        </select>
                    </div>         
                    <div class="form-group col-md-6">
                        <label for="lname">Start Time<span class="color">*</span>:</label>
                        <input
                            class="form-control"
                            type="time"
                            [(ngModel)]="eventDetails.eventStartTime"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="startTimeInPastError = false; refresh.next()"
                            placeholder="Pick Time"
                        />
                        <div *ngIf="startTimeInPastError" class="field-error">Please select a future time.</div>
                        <div *ngIf="requiredFieldErrors.eventStartTime" class="field-error">Please select required values</div>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="lname">End Time<span class="color">*</span>:</label>
                        <input
                            class="form-control"
                            type="time"
                            [(ngModel)]="eventDetails.eventEndTime"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="startTimeInPastError = false; refresh.next()"
                            placeholder="Pick Time"
                        />
                        <div *ngIf="requiredFieldErrors.eventEndTime" class="field-error">Please select required values</div>
                        <div *ngIf="endTimeError" class="field-error">End time should be greater than start time.</div>
                    </div>
                    <div class="form-group col-md-6" *ngIf="isUser">
                        <label for="city">Choose {{userType}}<span class="color">*</span>:</label>
                        <select [(ngModel)]="this.eventDetails.eventAudienceUserId" required class="form-control" [ngModelOptions]="{standalone: true}">
                            <option value="">Choose {{userType}}</option>
                            <option *ngFor="let users of userList" [value]="users.id">{{users.firstName+' '+users.lastName }}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6" *ngIf="isMember">
                        <label for="city">Members<span class="color">*</span>:</label>
                                                <input type="text" [(ngModel)]="memberName" [ngModelOptions]="{standalone: true}" placeholder="Search Member" class="form-control"
                                                    (keyup)="onMemberInputKeyup($event)" autocomplete="off"
                                                    (focus)="onMemberInputFocus()" (blur)="onMemberInputBlur()" />
                                                <div *ngIf="isSearchBoxShow" class="col-md-12 searchBox">
                                                    <span *ngIf="showPleaseText && memberName && memberName.trim().length > 0 && isLoadingMembers"> Please wait... </span>
                                                    <ul *ngIf="searchMembers && searchMembers.length > 0">
                                                        <li *ngFor="let member of searchMembers;let j = index">
                                                            <a (click)="onMemberSelected(member)" href="javascript:void(0)">{{member.firstName}} {{member.lastName}}</a>
                                                        </li>
                                                    </ul>
                                                </div>
                    </div>
                    <div class="form-group col-md-6" *ngIf="isTeam">
                        <label for="city">Teams<span class="color">*</span>:</label>
                        <select [(ngModel)]="team" class="form-control" [ngModelOptions]="{standalone: true}">
                            <option value="">Choose Team</option>
                            <option *ngFor="let teams of teamList" [value]="teams.teamId">{{ teams.teamName}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="lname">Time Zone<span class="color">*</span>:</label>
                        <select class="form-control" [(ngModel)]="eventDetails.timeZone" [ngModelOptions]="{standalone: true}" placeholder="Choose Option">
                        <div *ngIf="requiredFieldErrors.timeZone" class="field-error">Please select required values</div>
                            <option value="0" selected>Choose Option</option>
                            <option value="Asia/Kolkata">Asia/Kolkata</option>
                            <option value="America/Chicago">America/Chicago</option>
                            <option value="America/Los_Angeles">America/Los_Angeles</option>
                            <option value="America/New_York">America/New_York</option>
                            <option value="America/Denver">America/Denver</option>
                            <option value="America/Toronto">America/Toronto</option>
                            <option value="America/Vancouver">America/Vancouver</option>
                            <option value="America/Edmonton">America/Edmonton</option>
                            <option value="America/Halifax">America/Halifax</option>
                            <option value="America/Winnipeg">America/Winnipeg</option>
                            <option value="America/Regina">America/Regina</option>
                            <option value="America/St_Johns">America/St_Johns</option>
                            <option value="America/Montreal">America/Montreal</option>
                        </select>
                    </div>  
                    <div class="form-group col-md-12">
                        <label for="lname">Description:</label>
                        <textarea class="form-control" [(ngModel)]="eventDetails.eventDescription" [ngModelOptions]="{standalone: true}" cols="10" rows="2"></textarea>
                    </div>
                    <div class="form-group col-md-12">
                        <button type="submit" class="btn btn-primary">Add Event</button> &nbsp;
                        <button type="button" style="color:#FFF" class="btn btn-danger btn-outline-secondary" (click)="closeDialog(1)">
                            Close
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </p-dialog>
</div>

<div class="card flex justify-content-center" *ngIf="isEdit && !deleteConfirmVisible">
    <p-dialog header="Edit Event" class="dailogHeader" [(visible)]="visible" (click)="dialogCLose($event)" [style]="{width: '50vw'}">
        <div class="table-responsive">
            <form #f="ngForm" (ngSubmit)="updateEvent()">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label for="eventDate">Event Date<span class="color">*</span>:</label>
                        <input
                            id="eventDate"
                            class="form-control"
                            type="date"
                            [(ngModel)]="editEventDate"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="onEditEventDateChange()"
                            [min]="editMinDate"
                        />
                        <div *ngIf="editEventDateInPastError" class="field-error">
                            Past date can't be selected. Please select today or a future date.
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="lname">Event Title<span class="color">*</span>:</label>
                        <input class="form-control" [(ngModel)]="eventDetails.eventTitle" [ngModelOptions]="{standalone: true}" type="text" placeholder="" />
                    </div>  
                    <div class="form-group col-md-6">
                        <label for="lname">Event Type<span class="color">*</span>:</label>
                        <select *ngIf="this.userDetails.id == eventDetails.eventCreatedById" class="form-control" [(ngModel)]="eventDetails.eventType" (change)="changeEventType($event)" [ngModelOptions]="{standalone: true}" placeholder="Choose Option">
                            <option value="0" selected>Choose Option</option>
                            <option value="1">Call With Team</option>
                            <option value="2">Call With Member</option>
                            <option value="3" *ngIf="isMemberAdvocate">Call Between Member and Doctor</option>
                            <option value="4" *ngIf="isMemberAdvocate">Call Between Member and Nutritionist</option>
                            <option value="5" *ngIf="isMemberAdvocate">Call Between Member and Fitness Instructors</option>
                            <option value="6" *ngIf="isMemberAdvocate">Call Between Member and Psychologist</option>
                            <option value="7" *ngIf="isMemberAdvocate">Call Between Team and Doctor</option>
                            <option value="8" *ngIf="isMemberAdvocate">Call Between Team and Nutritionist</option>
                            <option value="9" *ngIf="isMemberAdvocate">Call Between Team and Fitness Instructors</option>
                            <option value="10" *ngIf="isMemberAdvocate">Call Between Team and Psychologist</option>
                        </select>
                        <input *ngIf="this.userDetails.id != eventDetails.eventCreatedById" class="form-control" type="text" [ngModelOptions]="{standalone: true}" readonly [(ngModel)]="eventTypeInfo"/>
                    </div>         
                    <div class="form-group col-md-6">
                        <label for="lname">Choose Time<span class="color">*</span>:</label>
                        <input
                            class="form-control"
                            type="time"
                            [(ngModel)]="eventDetails.eventStartTime"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="refresh.next()"
                            placeholder="Pick Time"
                        />
                        <div *ngIf="startTimeInPastError" class="field-error">Please select a future time.</div>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="lname">End Time<span class="color">*</span>:</label>
                        <input
                            class="form-control"
                            type="time"
                            [(ngModel)]="eventDetails.eventEndTime"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="refresh.next()"
                            placeholder="Pick Time"
                        />
                    </div>
                    <div class="form-group col-md-6" *ngIf="isUser">
                        <label for="city">Choose {{userType}}<span class="color">*</span>:</label> 
                        <select [(ngModel)]="this.eventDetails.eventAudienceUserId" required class="form-control" [ngModelOptions]="{standalone: true}">
                            <option value="">Choose {{userType}}</option>
                            <option *ngFor="let users of userList" [value]="users.id">{{users.firstName+' '+users.lastName }}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6" *ngIf="isMember">
                        <label for="city">Members<span class="color">*</span>:</label>
                        <input type="text" [(ngModel)]="memberName" [ngModelOptions]="{standalone: true}" placeholder="Search Member" class="form-control" (keyup)="searchMember($event)" />
                        <div *ngIf="isSearchBoxShow" class="col-md-12 searchBox">
                            <span *ngIf="showPleaseText && memberName && memberName.trim().length > 0 && (!searchMembers || searchMembers.length === 0)"> Please wait... </span>
                            <ul *ngIf="searchMembers && searchMembers.length > 0">
                                <li *ngFor="let member of searchMembers;let j = index"><a (click)="selectedMember(member)" href="javascript:void(0)">{{member.firstName}} {{member.lastName}}</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="form-group col-md-6" *ngIf="isTeam">
                        <label for="city">Teams<span class="color">*</span>:</label>
                        <select [(ngModel)]="this.eventDetails.eventAudienceTeamId" class="form-control" [ngModelOptions]="{standalone: true}">
                            <option value="">Choose Team</option>
                            <option *ngFor="let teams of teamList" [value]="teams.teamId">{{ teams.teamName}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="lname">Time Zone<span class="color">*</span>:</label>
                        <select class="form-control" [(ngModel)]="eventDetails.timeZone" [ngModelOptions]="{standalone: true}" placeholder="Choose Option">
                            <option value="0" selected>Choose Option</option>
                            <option value="Asia/Kolkata">Asia/Kolkata</option>
                            <option value="America/Chicago">America/Chicago</option>
                            <option value="America/Los_Angeles">America/Los_Angeles</option>
                            <option value="America/New_York">America/New_York</option>
                            <option value="America/Denver">America/Denver</option>
                            <option value="America/Toronto">America/Toronto</option>
                            <option value="America/Vancouver">America/Vancouver</option>
                            <option value="America/Edmonton">America/Edmonton</option>
                            <option value="America/Halifax">America/Halifax</option>
                            <option value="America/Winnipeg">America/Winnipeg</option>
                            <option value="America/Regina">America/Regina</option>
                            <option value="America/St_Johns">America/St_Johns</option>
                            <option value="America/Montreal">America/Montreal</option>
                        </select>
                    </div> 
                    <div class="form-group col-md-12">
                        <label for="lname">Call Link<span class="color">*</span>:</label>
                        <input class="form-control" readonly [(ngModel)]="eventDetails.callLink" [ngModelOptions]="{standalone: true}" type="text" placeholder="Call Link" />
                        <a href="{{eventDetails.callLink}}" target="_blank" class="btn btn-primary mt-3">Join Call</a>
                    </div>  
                    <div class="form-group col-md-12">
                        <label for="lname">Description:</label>
                        <textarea class="form-control" [(ngModel)]="eventDetails.eventDescription" [ngModelOptions]="{standalone: true}" cols="5" rows="1"></textarea>
                    </div>
                    <div class="form-group col-md-12">
                        <button type="submit" [disabled]="this.eventDetails.eventCreatedById != this.userDetails.id || disableUBtn" class="btn btn-primary">Update Event</button> &nbsp;&nbsp;
                        <button type="button" [disabled]="this.eventDetails.eventCreatedById != this.userDetails.id" (click)="confirmDelete(eventDetails.id,eventDetails.calendarEventId)" class="btn btn-danger">Delete Event</button>&nbsp;
                        <button type="button" style="color:#FFF" class="btn btn-danger btn-outline-secondary" (click)="closeDialog(2)">
                            Close
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </p-dialog>
    <p-confirmDialog [style]="{width: '30vw'}"></p-confirmDialog>
</div>

<!-- Custom Delete Confirmation Dialog -->
<div class="card flex justify-content-center" *ngIf="isDeleteConfirm">
    <!-- Modal Backdrop -->
    <div class="modal-backdrop" *ngIf="deleteConfirmVisible" (click)="cancelDelete()"></div>
    
    <p-dialog 
        header="Delete Event" 
        class="delete-confirmation-dialog" 
        [(visible)]="deleteConfirmVisible" 
        [style]="{width: '40vw'}"
        [modal]="true"
        [closable]="true"
        [draggable]="false"
        [resizable]="false"
        [blockScroll]="true"
        (onHide)="cancelDelete()">
        <div class="table-responsive">
            <div class="row">
                <div class="col-12 text-center mb-4">
                    <i class="pi pi-exclamation-triangle" style="font-size: 3rem; color: #dc3545;"></i>
                    <h4 class="mt-3 mb-3">Are you sure you want to delete this event?</h4>
                    <p class="text-muted">This action cannot be undone. The event will be permanently removed.</p>
                </div>
                <div class="col-12 text-center d-flex justify-content-center gap-3">
                    <button type="button" class="btn btn-danger" (click)="confirmDeleteAction()">
                        <i class="pi pi-trash me-2"></i>Yes
                    </button>
                    <button type="button" class="btn btn-outline-secondary" (click)="cancelDelete()">
                        <i class="pi pi-times me-2"></i>No
                    </button>
                </div>
            </div>
        </div>
    </p-dialog>
</div>

<!-- Past Date Message Dialog -->
<div class="card flex justify-content-center" *ngIf="isPastDateMessage">
    <!-- Modal Backdrop -->
    <div class="modal-backdrop" *ngIf="pastDateMessageVisible" (click)="closePastDateMessage()"></div>
    
    <p-dialog 
        header="Past Date Selected" 
        class="past-date-message-dialog" 
        [(visible)]="pastDateMessageVisible" 
        [style]="{width: '35vw'}"
        [modal]="true"
        [closable]="true"
        [draggable]="false"
        [resizable]="false"
        [blockScroll]="true"
        (onHide)="closePastDateMessage()">
        <div class="table-responsive">
            <div class="row">
                <div class="col-12 text-center mb-4">
                    <i class="pi pi-calendar-times" style="font-size: 3rem; color: #05445E;"></i>
                    <h4 class="mt-3 mb-3">Meeting cannot be scheduled in the past</h4>
                    <p class="text-muted">Please select a future time to schedule your meeting.</p>
                </div>
                <div class="col-12 text-center">
                    <button type="button" class="btn btn-primary" (click)="closePastDateMessage()">
                        <i class="pi pi-check me-2"></i>OK
                    </button>
                </div>
            </div>
        </div>
    </p-dialog>
</div>

<ng-template #modalContent let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Event action occurred</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div>
            Action:
            <pre>{{ modalData.action }}</pre>
        </div>
        <div>
            Event:
            <pre>{{ modalData.event | json }}</pre>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="close()">
            OK
        </button>
    </div>
</ng-template>